<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden bg-card">
    <ng-container *transloco="let t">
        <div
            class="flex flex-wrap justify-between items-center p-8 md:px-15 lg:px-30 xl:px-40 md:py-8 lg:py-8 xl:py-8"
        >
            <div class="flex justify-between items-center">
                <!-- <button
                    class="lg:hidden -ml-2"
                    mat-icon-button
                    (click)="showSidepanel()"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button> -->
                <!-- Title -->
                <div
                    class="ml-2 text-4xl uppercase font-semibold tracking-tight leading-tight"
                >
                    <span> {{ t("EXPORT-CSV") }} </span>
                </div>
            </div>
            <div class="flex items-center space-x-1">
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    cdkOverlayOrigin
                    #trigger="cdkOverlayOrigin"
                    (click)="isDeviceOverlayOpen = !isDeviceOverlayOpen"
                >
                    <mat-icon>add</mat-icon>
                    {{ t("ADD-IMEI") }}
                </button>

                @if(imeis?.length){
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="exportCSV()"
                >
                    <mat-icon>download</mat-icon>
                    {{ t("EXPORT-CSV") }}
                </button>

                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="imeis = []"
                >
                    <mat-icon>download</mat-icon>
                    {{ t("CLEAR-ALL") }}
                </button>
                }
            </div>
        </div>
        <div
            class="flex flex-col flex-1 overflow-auto p-8 md:px-15 lg:px-30 xl:px-40"
        >
            <div class="mb-4 flex-1 overflow-auto">
                <!-- imeis -->
                @for (imei of imeis; track $index) {
                <div class="flex justify-between my-2 p-2 bg-slate-50">
                    <span> {{ imei }}</span>
                    <span class="cursor-pointer" (click)="removeIMEI(imei)">
                        {{ t("REMOVE") }}
                    </span>
                </div>
                }
            </div>
        </div>

        <!-- This template displays the overlay content and is connected to the button -->
        <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="isDeviceOverlayOpen"
            (detach)="isDeviceOverlayOpen = false"
            (overlayOutsideClick)="isDeviceOverlayOpen = false"
        >
            <ul
                class="mt-1 p-4 bg-white border border-gray-400 rounded-sm flex flex-col space-y-1"
            >
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="openAddDeviceWithQRcodeDialog()"
                >
                    {{ t("QR-CODE") }}
                </button>
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="openAddMuitipleImeisDialog()"
                >
                    {{ t("MANUAL") }}
                </button>
            </ul>
        </ng-template>
    </ng-container>
</div>
